import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedAzureDevOpsCreateUserStoryReq } from 'app/interfaces/requests/Exposed/exposedAzureDevOpsCreateUserStoryReq';
import { ListAzureDevOpsWorkItemsPagedRes } from 'app/interfaces/responses/List/listAzureDevOpsWorkItemsPagedRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AzureService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public createUserStory(req: ExposedAzureDevOpsCreateUserStoryReq, attachements: File[] = [], showError = true): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sendi beiðni');

        const subject = new Subject<number>();
        const formData = new FormData();

        formData.append('title', req.title || '');
        formData.append('areaPath', req.areaPath || '');
        formData.append('iterationPath', req.iterationPath || '');
        formData.append('description', req.description || '');
        formData.append('assistTypeName', req.assistTypeName || '');

        for (const file of attachements) {
            formData.append('attachements', file, file.name);
        }

        this.http
            .post(environment.localApi + 'azuredevops/createUserStory', formData, this.httpRequestHelper.getRequestOptionsAuthFileUpload())
            .subscribe(
                (res: HttpStatus<number>) => {
                    subject.next(res.returnItem);
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Beiðni #' + res.returnItem + ' skráð');
                    this.alertsService.changeAlertSuccessShow(true);
                },
                (error) => {
                    subject.next(null);
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });

        return subject.asObservable();
    }

    public listWorkItems(pageSize: number, nextPageToken: string | null, showError = true): Observable<ListAzureDevOpsWorkItemsPagedRes> {
        const paramsObj: any = { pageSize: pageSize.toString() };
        if (nextPageToken) paramsObj.pageToken = nextPageToken;

        const params = new HttpParams({ fromObject: paramsObj });
        const subject = new Subject<ListAzureDevOpsWorkItemsPagedRes>();

        this.http.get(environment.localApi + 'azuredevops/work-items', {
            params,
            ...this.httpRequestHelper.getRequestOptionsAuth()
        }).subscribe(
            (res: HttpStatus<ListAzureDevOpsWorkItemsPagedRes>) => {
                subject.next(res.returnItem);
            },
            (error) => {
                subject.next(null);
                if (showError) {
                    HttpError(this.alertsService, this.router, error, "", "", "", "");
                } else {
                    console.log(error);
                }
                subject.error(error);
            }
        );
        return subject.asObservable();
    }
}
